import { getAssetPath } from '@stencil/core';
let registry = [
  {
    name: 'bootstrap',
    resolver: (name) => getAssetPath(`./libraries/bootstrap/${name}.svg`),
  },
];
registry.push({
  name: '23',
  resolver: (name) => getAssetPath(`./libraries/twentythree/${name}.svg`),
  mutator: (svg) => {
    for (const child of svg.querySelectorAll('*[fill="#AAAAAA"]')) {
      child.removeAttribute('fill');
    }
    svg.setAttribute('fill', 'currentColor');
  },
});
// one library
const subLibraries = ['', '/global', '/spots', '/webinars', '/logos', '/web-editor', '/highlights', '/wysiwyg'];
subLibraries.forEach((subLib) => {
  registry.push({
    name: `one${subLib}`,
    resolver: (name) => getAssetPath(`./libraries/one${subLib || '/global'}/${name}.svg`),
    mutator: (svg) => {
      for (const child of svg.querySelectorAll('*[fill="#000000"],*[fill="#222222"],*[fill="black"]')) {
        child.setAttribute('fill', 'currentColor');
      }
      for (const child of svg.querySelectorAll('*[stroke="#000000"],*[stroke="#222222"],*[stroke="black"]')) {
        child.setAttribute('stroke', 'currentColor');
      }
    },
  });
});
registry.push({
  name: `one/flags`,
  resolver: (name) => getAssetPath(`./libraries/one/flags/${name}.svg`),
});
let watchedIcons = [];
export function watchIcon(icon) {
  watchedIcons.push(icon);
}
export function unwatchIcon(icon) {
  watchedIcons = watchedIcons.filter((el) => el !== icon);
}
export function getLibrary(name) {
  return registry.filter((lib) => lib.name === name)[0];
}
export function registerLibrary(name, resolver, mutator) {
  unregisterLibrary(name);
  registry.push({ name, resolver, mutator });
  // Redraw watched icons
  watchedIcons.map((icon) => {
    if (icon.library === name) {
      icon.redraw();
    }
  });
}
export function unregisterLibrary(name) {
  registry = registry.filter((lib) => lib.name !== name);
}
